import styled from "styled-components";
import { type ArrowProps } from "./arrow";
import { getBackgroundColor } from "./arrow.styles.utils";
import { deepMerge } from "@components/common/utils/helper";

type WrapperProps = Pick<ArrowProps, "color">;

export const Wrapper = styled.div<WrapperProps>(({ color, theme }) => ({
    position: "relative",
    width: theme.spacing[2.5],
    height: theme.spacing[2.5],
    "&:before, &:after": {
        content: '""',
        position: "absolute",
        left: theme.spacing[0.5],
        width: "7px",
        height: theme.spacing[0.5],
        top: "50%",
        marginTop: `-${theme.spacing.px}`,
        ...deepMerge(getBackgroundColor(color, theme)),
        borderRadius: theme.borderRadius.full,
        translate: "0 0",
        transitionProperty: "translate",
        transitionDuration: "300ms",
        transitionTimingFunction: theme.transitionTimingFunction["out-cubic"],
    },
    "&:before": {
        rotate: "45deg",
        translate: `0 -${theme.spacing[0.5]}`,
    },
    "&:after": {
        rotate: "-45deg",
        translate: `0 ${theme.spacing[0.5]}`,
    },
}));
